import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { LookoButton, LookoModal, VStack } from '@looko-design-system';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';

import { 세컨솔드_설정_라우터 } from '@/router/linkage/setting';

import { useShopInfo2 } from './shop/shop-info/hooks';

const LOCAL_STORAGE_KEY = 'lastClickDate-aclosetShopInfo' as const;

/**
 * 세컨솔드 샵 소개 정보 설정 필요 모달
 */
export default function AclosetShopInfoModal() {
  // route
  const location = useLocation();
  const navigate = useNavigate();

  // hook
  const { shopInfo } = useShopInfo2();

  // local
  const lastClickDate = localStorage.getItem(LOCAL_STORAGE_KEY);
  const 샵소개설정 = shopInfo.acloset.shopDescription;
  const 샵소개설정_필요한가 = !(
    !!샵소개설정?.keywords &&
    !!샵소개설정.productFocuses &&
    !!샵소개설정.storeLocations?.region &&
    !!샵소개설정.storeLocations.subRegion
  );

  const [isOpen, setIsOpen] = React.useState(샵소개설정_필요한가 && dayjs().format('YYYY.MM.DD') !== lastClickDate);

  // handler
  const handleClickButton = () => {
    const lastClickDate = dayjs().format('YYYY.MM.DD');

    localStorage.setItem(LOCAL_STORAGE_KEY, lastClickDate);
    setIsOpen(샵소개설정_필요한가 && dayjs().format('YYYY.MM.DD') !== lastClickDate);
  };

  React.useEffect(() => {
    setIsOpen(샵소개설정_필요한가 && dayjs().format('YYYY.MM.DD') !== lastClickDate);
  }, [lastClickDate, location.pathname, 샵소개설정_필요한가]);

  /**
   * 모달 노출 제외 페이지
   *
   * 세컨솔드 프로셀러 설정 페이지
   */
  const hideModalPath = [세컨솔드_설정_라우터.프로필_설정.path];

  if (hideModalPath.includes(location.pathname)) {
    return;
  }

  return (
    <LookoModal open={isOpen}>
      <LookoModal.Header>샵 소개 정보 설정 필요</LookoModal.Header>
      <LookoModal.Content>
        <VStack width={500}>
          <Typography variant="Body_Looko">
            세컨솔드에서 구매자에게 샵을 소개하고 추천하기 위해서 샵 정보에 대한 간단한 설정이 필요합니다.
          </Typography>
          <br></br>
          <Typography variant="Body_Looko">
            *해당 설정은 <b>1분</b> 정도 소요됩니다.
          </Typography>
          <Typography variant="Body_Looko">{'*’대시보드>4단계 샵 정보 입력’에서 설정이 가능합니다.'}</Typography>
        </VStack>
      </LookoModal.Content>

      <LookoModal.Actions>
        <LookoButton onClick={() => navigate(세컨솔드_설정_라우터.프로필_설정.path)} variant="outlined">
          설정하러 가기
        </LookoButton>
        <LookoButton onClick={handleClickButton}>확인</LookoButton>
      </LookoModal.Actions>
    </LookoModal>
  );
}
